import { useEffect } from "react";
import { useApp } from "../context/AppContext";

/**
 * Auto-selects the first available ITE event when no event is currently
 * selected and the events list has finished loading.
 *
 * Call this at the top of any page where showing data immediately (without
 * requiring the user to manually pick an event) improves the experience.
 *
 * Behaviour:
 *   - Fires on mount and whenever the events array changes (i.e. once after load).
 *   - Does nothing if an event is already selected — never overrides a user choice.
 *   - If the user clears the selection within the page session, the hook does NOT
 *     re-fire (events didn't change), so the user retains the "All Events" view.
 *   - On remount (page navigation away and back), applies the default again if the
 *     selection is still empty.
 */
export function useDefaultEvent() {
  const { selectedEvent, setSelectedEvent, events } = useApp();

  useEffect(() => {
    if (!selectedEvent && events?.length > 0) {
      setSelectedEvent(events[0].ite_event_id);
    }
  }, [events]); // eslint-disable-line react-hooks/exhaustive-deps
}
